import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.filter((a) => !a.isFeatured).slice(0, 6);

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-1">第一时间掌握最新黑料资讯</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <ArticleCard
              key={article.id}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              coverImage={article.coverImage}
              categoryName={article.categoryName}
              categorySlug={article.category}
              author={article.author}
              publishDate={article.publishDate}
              readTime={article.readTime}
              views={article.views}
            />
          ))}
        </div>
      </div>
    </section>
  );
}